import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-short-map",
  templateUrl: "./short-map.component.html",
  styleUrls: ["./short-map.component.scss"],
})
export class ShortMapComponent implements OnInit {
  @Input() latitude: string;
  @Input() longitude: string;

  zoom = 18;
  center?: google.maps.LatLngLiteral;
  markerPosition?: google.maps.LatLngLiteral;

  constructor() {}

  ngOnInit(): void {
    if (this.latitude && this.longitude) {
      this.center = {
        lat: parseFloat(this.latitude),
        lng: parseFloat(this.longitude),
      };
      this.markerPosition = {
        lat: parseFloat(this.latitude),
        lng: parseFloat(this.longitude),
      };
    }
  }
}
